import React from "react"
import { Link } from "gatsby"

import { ThemeProvider, makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

import { theme } from '../styles/theme';
import HeaderBar from '../components/header-bar';

import { Provider } from "react-redux"
import createStore from "../store/store.js"

import Amplify from 'aws-amplify';
import awsconfig from "../aws-exports";
import { AmplifyAuthenticator, AmplifySignIn } from '@aws-amplify/ui-react';

import { amplifyLangJa } from '../amplify-auth-lang'
import * as AmplifyModules from 'aws-amplify'

Amplify.configure(awsconfig);
AmplifyModules.I18n.putVocabulariesForLanguage('ja', amplifyLangJa);

export const store = createStore()

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: `white`,
  },
  footerLinks: {
    paddingTop: theme.spacing(4),
    textAlign: `center`,
  },
  link: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  }
}));

const Layout = ({ location, title, children, isFooter = true, pointName = false }) => {

  const rootPath = `${__PATH_PREFIX__}/`
  const isRootPath = location.pathname === rootPath

  const classes = useStyles();

  const [user, setUser] = React.useState(null);

  React.useEffect(() => {
    async function getAuth() {
      return await Amplify.Auth.currentUserPoolUser()
    }
    getAuth().then(v => setUser(v))
    .catch(() => setUser(false));
  }, []);

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
          <HeaderBar user={user} />
          <div data-is-root-path={isRootPath} className={classes.offset}>
            <AmplifyAuthenticator usernameAlias="email">
              <AmplifySignIn
                slot="sign-in"
                hideSignUp={true}
                formFields={[
                {
                  type: "username",
                  label: "ユーザーID",
                  placeholder: "ユーザーIDを入力",
                  required: true,
                },
                {
                  type: "password",
                  label: "パスワード",
                  placeholder: "パスワードを入力",
                  required: true,
                },
              ]}
              />
              <main>{children}</main>
            </AmplifyAuthenticator>
          </div>
          { isFooter ? (
            <footer className={classes.footer}>
              <Container>
                <Grid container alignItems="center" justify="center">
                  <Grid item xs={8}>
                    <div className={classes.footerLinks}>
                      <Link className={classes.link} to="/howto/">使い方</Link>
                      <Link className={classes.link} to="/terms/">利用規約</Link>
                      <Link className={classes.link} to="/privacy/">プライバシー</Link>
                      <Link className={classes.link} to="/law/">商取引法に基づく表記</Link>
                    </div>
                  </Grid>
                </Grid>
                <div className={classes.footerLinks}>
                  Copyright © {new Date().getFullYear()}
                  {` `}
                  <a href="https://ukai-mnap.co.jp.com">UKAI K.K.</a> All Rights Reserved.
                </div>
              </Container>
            </footer>
          ) : ""
        }
      </ThemeProvider>
    </Provider>
  )
}

export default Layout
